// extracted by mini-css-extract-plugin
export default {"dialogTitle":"ChatFoldersModal_dialogTitle__eedp3","dialogContent":"ChatFoldersModal_dialogContent__81mkp","subTitle":"ChatFoldersModal_subTitle__KZIqq"};